// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1o9u8","tab":"Tabs_tab__N_wkA","tabActive":"Tabs_tabActive__-CYP_"};